import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/menu.svg'
import _imports_1 from '@/assets/icons/ticket.svg'
import _imports_2 from '@/assets/icons/chat-speech-bubble.svg'
import _imports_3 from '@/assets/icons/qrcode.svg'


const _withScopeId = n => (_pushScopeId("data-v-5da0bf40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-menu",
  src: _imports_0,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "nav-title-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "env-flag"
}
const _hoisted_5 = {
  key: 1,
  class: "env-flag"
}
const _hoisted_6 = {
  key: 0,
  class: "img-wrapper"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-ticket",
  src: _imports_1,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-twc",
  src: _imports_2,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_9 = {
  key: 1,
  class: "img-wrapper"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-qrcode",
  src: _imports_3,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-twc",
  src: _imports_2,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav", { underline: $props.shouldShowUnderline }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "img-menu-btn",
        to: { name: $setup.RouterName.MyPage },
        "aria-label": "메뉴 열기"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        ($setup.isDev)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(개발)"))
          : _createCommentVNode("v-if", true),
        ($setup.isStage)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(스테이지)"))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.bookRequiredType === $setup.BookRequiredType.NO_BOOK_REQUIRED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "img-ticket-btn",
              to: { name: $setup.RouterName.BoardHistory },
              "aria-label": "탑승내역 화면으로 이동"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]),
            _createVNode(_component_router_link, {
              class: "img-search-btn",
              to: { name: $setup.RouterName.LineSearch },
              "aria-label": "노선 검색 화면으로 이동"
            }, {
              default: _withCtx(() => [
                _createVNode($setup["InlineSvg"], {
                  class: "img-search",
                  src: require('@/assets/icons/search.svg'),
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]),
            ($setup.serviceInfo?.boardCheckCode === $setup.BoardCheckCode.QRTAG)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "img-twc-btn",
                  to: {
            name: $setup.RouterName.Chat,
            query: {
              loginId: $setup.userInfo?.loginId,
              name: $setup.userInfo?.alias,
              phone: $setup.userInfo?.phone,
              email: $setup.userInfo?.email,
              clientName: $setup.userInfo?.clientName,
            },
          },
                  "aria-label": "챗봇 문의 페이지로 이동"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_router_link, {
              class: "img-notice-btn",
              to: { name: $setup.RouterName.Notice },
              "aria-label": "공지사항 화면으로 이동"
            }, {
              default: _withCtx(() => [
                _createVNode($setup["InlineSvg"], {
                  class: "img-notice",
                  src: require('@/assets/icons/megaphone.svg'),
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            ($setup.serviceInfo?.boardCheckCode === $setup.BoardCheckCode.QRTAG)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "img-qrcode-btn",
                  to: { name: $setup.RouterName.MobileId },
                  "aria-label": "모바일 ID 화면으로 이동"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_router_link, {
              class: "img-search-btn",
              to: { name: $setup.RouterName.LineSearch },
              "aria-label": "노선 검색 화면으로 이동"
            }, {
              default: _withCtx(() => [
                _createVNode($setup["InlineSvg"], {
                  class: "img-search",
                  src: require('@/assets/icons/search.svg'),
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]),
            _createVNode(_component_router_link, {
              class: "img-twc-btn",
              to: {
            name: $setup.RouterName.Chat,
            query: {
              loginId: $setup.userInfo?.loginId,
              name: $setup.userInfo?.alias,
              phone: $setup.userInfo?.phone,
              email: $setup.userInfo?.email,
              clientName: $setup.userInfo?.clientName,
            },
          },
              "aria-label": "챗봇 문의 페이지로 이동"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]),
            _createVNode(_component_router_link, {
              class: "img-notice-btn",
              to: { name: $setup.RouterName.Notice },
              "aria-label": "공지사항 화면으로 이동"
            }, {
              default: _withCtx(() => [
                _createVNode($setup["InlineSvg"], {
                  class: "img-notice",
                  src: require('@/assets/icons/megaphone.svg'),
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]))
    ])
  ], 2 /* CLASS */))
}